export enum Jurisdiction {
    NONE = 'none',
    BRAZIL = 'brazil',
    LITHUANIA = 'lithuania',
    UNITED_KINGDOM = 'united_kingdom',
    PORTUGAL = 'portugal',
    SOUTH_AFRICA = 'south_africa',
}
